import styled from "styled-components";
const Row = styled("div")<{align?: string, gap?: string}>`
    display: flex;
    justify-content: ${(props) => props.align ? props.align : "center"};
    align-items: center;
    gap: ${(props) => props.gap ? props.gap : "0"};
`;


export default Row;